// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSecondaryProgramsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryProgramDTO from '../models/SecondaryProgramDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYearId: number;
    secondaryProgramId: number | null | null;
    districtId: string | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYearId: 0,
            secondaryProgramId: null,
            districtId: null,
        },
        initValues);
    },
    academicYearId: 'academicYearId',
    secondaryProgramId: 'secondaryProgramId',
    districtId: 'districtId',
}

interface Result extends ResultDTO {
    secondaryPrograms: SecondaryProgramDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryPrograms: [],
        },
        initValues);
    },
    secondaryPrograms: 'secondaryPrograms',
}

export { Request, Result };